import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Typography,
    Container,
    Button,
    Modal,
    IconButton,
    Divider,
    useMediaQuery,
} from "@mui/material";
import { gsap } from "gsap";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { masterlayoutbg } from "../../../../../assets";

// ✅ Updated floor plan data with floors per facing
const floorPlansData = [

    {
        id: 1,
        bhk: "4BHK",
        size: "5367",
        facings: [
            {
                name: "West",
                floors: [
                    {
                        label: "Ground Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/groundfloor%20planwest_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/groundfloor%20planwest_s.png",
                    },
                    {
                        label: "First Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/fistfloorwest_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/fistfloorwest_s.png",
                    },
                    {
                        label: "Second Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/secondfloorwest_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/secondfloorwest_s.png",
                    },
                    {
                        label: "Terrace Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/terracewest_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/300westplans/terracewest_s.png",
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        bhk: "4BHK",
        size: "5615",
        facings: [
            {
                name: "East",
                floors: [
                    {
                        label: "Ground Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/grondfloorplaneast_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/grondfloorplaneast_s.png",
                    },
                    {
                        label: "First Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/firstfloorplaneast_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/firstfloorplaneast_s.png",
                    },
                    {
                        label: "Second Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/secondfloorplaneast_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/secondfloorplaneast_s.png",
                    },
                    {
                        label: "Terrace Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/terracefloorplaneast_s.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/terracefloorplaneast_s.png",
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        bhk: "4BHK",
        size: "6349 ",
        facings: [
            {
                name: "West",
                floors: [
                    {
                        label: "Ground Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/groundwest_m.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/groundwest_m.png",
                    },
                    {
                        label: "First Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/firstwest_m.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/firstwest_m.png",
                    },
                    {
                        label: "Second Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/secondwest_m.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/secondwest_m.png",
                    },
                    {
                        label: "Terrace Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/terracewest_m.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/terracewest_m.png",
                    },
                ],
            },
        ],
    },
    {
        id: 4,
        bhk: "4BHK",
        size: "6884",
        facings: [
            {
                name: "East",
                floors: [
                    {
                        label: "Ground Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/groundeast_m.pngg",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/groundeast_m.png",
                    },
                    {
                        label: "First Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/firstflooreast_m.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/firstflooreast_m.png",
                    },
                    {
                        label: "Second Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/secondeast_m.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/secondeast_m.png",
                    },
                    {
                        label: "Terrace Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/terraceeast_m.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/354floorplans/terraceeast_m.png",
                    },
                ],
            },
        ],
    },

    {
        id: 5,
        bhk: "5BHK",
        size: "7189  ",
        facings: [
            {
                name: "West",
                floors: [
                    {
                        label: "Ground Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/groundwest.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/groundwest.png",
                    },
                    {
                        label: "First Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/firstwest.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/firstwest.png",
                    },
                    {
                        label: "Second Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/west.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/west.png",
                    },
                    {
                        label: "Terrace Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/terracewest.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/terracewest.png",
                    },
                ],
            },
        ],
    },
    {
        id: 6,
        bhk: "5BHK",
        size: "7406  ",
        facings: [
            {
                name: "East",
                floors: [
                    {
                        label: "Ground Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/groundwest.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/groundwest.png",
                    },
                    {
                        label: "First Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/firsteast.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/firsteast.png",
                    },
                    {
                        label: "Second Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/secondeast.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/secondeast.png",
                    },
                    {
                        label: "Terrace Floor",
                        image: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/terraceeast.png",
                        downloadImage: "https://dprstorage.b-cdn.net/RW/projects/villaverdefloorplans/440floorplans/terraceeast.png",
                    },
                ],
            },
        ],
    },
];

interface VillaVerdeFloorPlansProps {
    title?: string;
}

const VillaVerdeFloorPlans: React.FC<VillaVerdeFloorPlansProps> = ({ title }) => {
    const textRef = useRef<HTMLDivElement | null>(null);
    const imageRef = useRef<HTMLDivElement | null>(null);

    const [selectedBHK, setSelectedBHK] = useState(floorPlansData[0]);
    const [selectedFacing, setSelectedFacing] = useState(floorPlansData[0].facings[0]);
    const [selectedFloor, setSelectedFloor] = useState(floorPlansData[0].facings[0].floors[0]);
    const [openModal, setOpenModal] = useState(false);
    const isMobile = useMediaQuery("(max-width: 768px)");

    // Animate when facing/floor changes
    useEffect(() => {
        if (textRef.current) {
            gsap.fromTo(textRef.current, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1, ease: "power2.out" });
        }
        if (imageRef.current) {
            gsap.fromTo(imageRef.current, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 1.2, ease: "power2.out", delay: 0.3 });
        }
    }, [selectedFloor, selectedFacing]);

    // Keep facing/floor synced when BHK changes
    useEffect(() => {
        if (!selectedBHK.facings.includes(selectedFacing)) {
            const firstFacing = selectedBHK.facings[0];
            setSelectedFacing(firstFacing);
            setSelectedFloor(firstFacing.floors[0]);
        }
    }, [selectedBHK]);

    // Sync floor on facing change
    useEffect(() => {
        setSelectedFloor(selectedFacing.floors[0]);
    }, [selectedFacing]);

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = selectedFloor.downloadImage;
        link.download = `${selectedBHK.bhk}-${selectedFacing.name}-${selectedFloor.label}.jpg`;
        link.click();
    };

    const handlePrevNext = (dir: "prev" | "next") => {
        const currentIndex = floorPlansData.findIndex((p) => p.id === selectedBHK.id);
        const newIndex = dir === "prev"
            ? (currentIndex - 1 + floorPlansData.length) % floorPlansData.length
            : (currentIndex + 1) % floorPlansData.length;
        const newBHK = floorPlansData[newIndex];
        setSelectedBHK(newBHK);
        setSelectedFacing(newBHK.facings[0]);
        setSelectedFloor(newBHK.facings[0].floors[0]);
    };

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                backgroundImage: `url(${masterlayoutbg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                overflow: "hidden",
                "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    zIndex: 1,
                },
            }}
        >
            <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2, py: 8 }}>
                {/* Title */}
                <Box sx={{ textAlign: "center" }}>
                    <Typography variant="h4" fontWeight={600} color="white">
                        FLOOR PLANS 
                    </Typography>
                    <Divider sx={{ width: { xs: "300px", md: "400px" }, height: "1px", backgroundColor: "white", mx: "auto", my: 2 }} />
                </Box>

                {/* BHK Tabs */}
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2, flexWrap: "wrap", gap: "8px" }}>
                    {floorPlansData.map((plan) => (
                        <Button
                            key={plan.id}
                            variant="contained"
                            onClick={() => {
                                setSelectedBHK(plan);
                                setSelectedFacing(plan.facings[0]);
                                setSelectedFloor(plan.facings[0].floors[0]);
                            }}
                            sx={{
                                background: selectedBHK.id === plan.id ? "#14658B" : "transparent",
                                color: "white",
                                border: "1px solid white",
                                py: 2,
                                borderRadius: 0,
                                fontWeight: 700,
                                "&:hover": { background: "#14658B" },
                                textTransform: "none",
                                fontSize: { xs: 14, md: 18 },
                                width: { xs: "calc(50% - 8px)", md: "auto" },
                            }}
                        >
                            {plan.bhk} – {plan.size} SQ.FT
                        </Button>
                    ))}
                </Box>

                {/* Facing Tabs */}
                <Box sx={{ display: "flex", justifyContent: "center", mb: 3, gap: 3, flexWrap: "wrap" }}>
                    {selectedBHK.facings.map((facing) => (
                        <Typography
                            variant="h5"
                            key={facing.name}
                            onClick={() => setSelectedFacing(facing)}
                            sx={{
                                cursor: "pointer",
                                color: selectedFacing.name === facing.name ? "white" : "#bbb",
                                fontWeight: selectedFacing.name === facing.name ? 700 : 500,
                                borderBottom: selectedFacing.name === facing.name ? "2px solid #14658B" : "2px solid transparent",
                                pb: "4px",
                                transition: "all 0.3s ease",
                                fontSize: { xs: 14, md: 16 },
                            }}
                        >
                            {facing.name.toUpperCase()}
                        </Typography>
                    ))}
                </Box>

                {/* Floor Tabs */}
                <Box sx={{ display: "flex", justifyContent: "center", mb: 3, gap: 2, flexWrap: "wrap" }}>
                    {selectedFacing.floors.map((floor) => (
                        <Button
                            key={floor.label}
                            onClick={() => setSelectedFloor(floor)}
                            sx={{
                                background: selectedFloor.label === floor.label ? "#14658B" : "transparent",
                                color: "white",
                                border: "1px solid white",
                                borderRadius: 0,
                                fontWeight: 700,
                                textTransform: "none",
                                fontSize: { xs: 13, md: 15 },
                                "&:hover": { background: "#14658B" },
                            }}
                        >
                            {floor.label}
                        </Button>
                    ))}
                </Box>

                {/* Image */}
                <Box ref={imageRef} sx={{
                    textAlign: "center", width: "100%", maxWidth: "512px", height: "512px",
                    mx: "auto", position: "relative"
                }}>
                    <img
                        src={selectedFloor.image}
                        alt={`${selectedBHK.bhk} ${selectedFacing.name} ${selectedFloor.label}`}
                        style={{
                            width: "100%",
                            objectFit: "contain",
                            borderRadius: 8,
                            border: "1px solid #fff",
                            padding: "5px",
                            boxShadow: "0 0 15px rgba(15,99,165,0.7)",
                            cursor: "pointer",
                        }}
                        onClick={() => setOpenModal(true)}
                    />
                </Box>

                {/* Details */}
                <Box ref={textRef} sx={{ textAlign: "center", mt: 4 }}>
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: 18,
                            maxWidth: "800px",
                            mx: "auto",
                            lineHeight: 1.6,
                            color: "white",
                        }}
                    >
                        {/* {selectedFacing.details || ""} */}
                    </Typography>
                </Box>

                {/* Modal */}
                <Modal open={openModal} onClose={() => setOpenModal(false)}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "100vh",
                            width: "100%",
                            py: "60px",
                            px: { xs: "16px", md: "0px" },
                            backgroundColor: "rgba(0,0,0,0.95)",
                            position: "relative",
                        }}
                    >
                        <IconButton sx={{ position: "absolute", top: 20, right: 20, color: "white" }} onClick={() => setOpenModal(false)}>
                            <CloseIcon sx={{ fontSize: 40 }} />
                        </IconButton>
                        <IconButton sx={{ position: "absolute", top: 20, left: 20, color: "white" }} onClick={handleDownload}>
                            <DownloadIcon sx={{ fontSize: 40 }} />
                        </IconButton>

                        {/* Prev / Next */}
                        <IconButton
                            sx={{ position: "absolute", top: "50%", left: { xs: 10, md: 20 }, color: "white", transform: "translateY(-50%)" }}
                            onClick={() => handlePrevNext("prev")}
                        >
                            <ArrowBackIosIcon sx={{ fontSize: { xs: 30, md: 40 } }} />
                        </IconButton>
                        <IconButton
                            sx={{ position: "absolute", top: "50%", right: { xs: 10, md: 20 }, color: "white", transform: "translateY(-50%)" }}
                            onClick={() => handlePrevNext("next")}
                        >
                            <ArrowForwardIosIcon sx={{ fontSize: { xs: 30, md: 40 } }} />
                        </IconButton>

                        <Box
                            component="img"
                            src={selectedFloor.downloadImage}
                            alt="Full Floor Plan"
                            sx={{
                                maxWidth: "90%",
                                maxHeight: "calc(100vh - 120px)",
                                borderRadius: 2,
                                boxShadow: "0 0 30px rgba(255,255,255,0.3)",
                                objectFit: "contain",
                            }}
                        />
                    </Box>
                </Modal>
            </Container>
        </Box>
    );
};

export default VillaVerdeFloorPlans;
